module.exports = __webpack_public_path__ + "fonts/ac7376487bdc4ce64eefffa0b6700b6b.svg";